import { Control, Controller, FieldValues } from "react-hook-form";
import { Select, InputLabel, MenuItem } from "@mui/material";
import styled from "styled-components";

export type SelectFieldOption = {
  value: string | number;
  label: string;
};

type Props = {
  label: string;
  defaultValue?: string | number | null;
  options: SelectFieldOption[];
  onChange?: any;
  value: any;
};

const SelectCommon = ({
  label,
  value,
  defaultValue,
  options,
  onChange,
}: Props) => {
  // console.log("defaultValue", defaultValue, typeof defaultValue);
  const menuItems = options.map((option: SelectFieldOption, index: number) => (
    <MenuItem value={option.value} key={`option_${index}`}>
      {option.label}
    </MenuItem>
  ));
  const labelId = `label_select_common`;

  return (
    <Div>
      <SelectLabel id={labelId}>{label}</SelectLabel>
      <SelectElement
        labelId={labelId}
        onChange={onChange}
        label={label}
        value={value}
        defaultValue={defaultValue}
      >
        {menuItems}
      </SelectElement>
    </Div>
  );
};

const SelectLabel = styled(InputLabel)`
  &&& {
    margin-right: 0.75rem;
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
`;

const SelectElement = styled(Select)`
  margin-left: 0rem;
  min-width: 5rem;
`;

export default SelectCommon;
